export const crossCountryData = [
  {
    Country: 'Armenia',
    poverty_reduction_basic: -0.35,
    poverty_reduction_enhanced: -0.43,
    poverty_reduction_ap_basic: -0.2,
    poverty_reduction_ap_enhanced: -0.41,
    inequality_reduction: -0.06,
    coverage: 0.834,
    consumption: 0.15,
    pmt_child: 0.411,
    pmt_disability: 0.511,
    pmt_old: 0.437,
    cost: 0.036,
    coverage_child: 0.612,
    coverage_disability: 0.173,
    coverage_old: 0.4,
    inequality_reduction_2: -0.06028368794,
    inequality_reduction_ap: -0.1731728257,
    poverty_rate_no: 9.08,
    poverty_rate_basic: 4.39,
    poverty_rate_enhanced: 3.96,
    poverty_rate_ipl: 'USD 5.5',
    pmt_child_included: 0.589,
    pmt_child_excluded: 0.411,
    pmt_disability_included: 0.7,
    pmt_disability_excluded: 0.3,
    pmt_old_included: 0.563,
    pmt_old_excluded: 0.437,
    cost_child: 2,
    cost_disability: 0.69,
    cost_old: 1.05,
    cost_combined: 4,
    cost_ap: 4,
    cost_global: 12.9,
    cost_oecd: 20,
    poverty_change_household: 0.148,
    poverty_change_basic: 0.3513909224
  },
  {
    Country: 'Bangladesh',
    poverty_reduction_basic: -0.11,
    poverty_reduction_enhanced: -0.48,
    poverty_reduction_ap_basic: -0.2,
    poverty_reduction_ap_enhanced: -0.41,
    inequality_reduction: -0.12,
    coverage: 0.81,
    consumption: 0.15,
    pmt_child: 0.49,
    pmt_disability: 0.37,
    pmt_old: 0.32,
    cost: 0.03,
    coverage_child: 0.68,
    coverage_disability: 0.07,
    coverage_old: 0.57,
    inequality_reduction_2: -0.1,
    inequality_reduction_ap: -0.1731728257,
    poverty_rate_no: 58.59,
    poverty_rate_basic: 51.52,
    poverty_rate_enhanced: 49.92,
    poverty_rate_ipl: 'USD 3.2',
    pmt_child_included: 0.51,
    pmt_child_excluded: 0.49,
    pmt_disability_included: 0.41,
    pmt_disability_excluded: 0.59,
    pmt_old_included: 0.47,
    pmt_old_excluded: 0.53,
    cost_child: 3,
    cost_disability: 0.1,
    cost_old: 2,
    cost_combined: 5,
    cost_ap: 4,
    cost_global: 12.9,
    cost_oecd: 20,
    poverty_change_household: 0.08,
    poverty_change_basic: 0.21
  },
  {
    Country: 'Bhutan',
    poverty_reduction_basic: -0.12,
    poverty_reduction_enhanced: -0.36,
    poverty_reduction_ap_basic: -0.2,
    poverty_reduction_ap_enhanced: -0.41,
    inequality_reduction: -0.25,
    coverage: 0.83,
    consumption: 0.14,
    pmt_child: 0.52,
    pmt_disability: 0.53,
    pmt_old: 0.34,
    cost: 0.06,
    coverage_child: 0.52,
    coverage_disability: 0.07,
    coverage_old: 0.51,
    inequality_reduction_2: -0.26,
    inequality_reduction_ap: -0.1731728257,
    poverty_rate_no: 8.15,
    poverty_rate_basic: 3.51,
    poverty_rate_enhanced: 3.15,
    poverty_rate_ipl: 'USD 3.2',
    pmt_child_included: 0.59,
    pmt_child_excluded: 0.41,
    pmt_disability_included: 0.4,
    pmt_disability_excluded: 0.6,
    pmt_old_included: 0.51,
    pmt_old_excluded: 0.49,
    cost_child: 2,
    cost_disability: 0.2,
    cost_old: 1,
    cost_combined: 3,
    cost_ap: 4,
    cost_global: 12.9,
    cost_oecd: 20,
    poverty_change_household: 0.11,
    poverty_change_basic: 0.24
  },
  {
    Country: 'Cambodia',
    poverty_reduction_basic: -0.22,
    poverty_reduction_enhanced: -0.39,
    poverty_reduction_ap_basic: -0.2,
    poverty_reduction_ap_enhanced: -0.41,
    inequality_reduction: -0.15,
    coverage: 0.78,
    consumption: 0.06,
    pmt_child: 0.3,
    pmt_disability: 0.47,
    pmt_old: 0.38,
    cost: 0.01,
    coverage_child: 0.63,
    coverage_disability: 0.08,
    coverage_old: 0.59,
    inequality_reduction_2: -0.25,
    inequality_reduction_ap: -0.1731728257,
    poverty_rate_no: 4.03,
    poverty_rate_basic: 2.56,
    poverty_rate_enhanced: 2.41,
    poverty_rate_ipl: 'USD 3.2',
    pmt_child_included: 0.49,
    pmt_child_excluded: 0.51,
    pmt_disability_included: 0.42,
    pmt_disability_excluded: 0.58,
    pmt_old_included: 0.5,
    pmt_old_excluded: 0.5,
    cost_child: 2,
    cost_disability: 0.3,
    cost_old: 1,
    cost_combined: 3,
    cost_ap: 4,
    cost_global: 12.9,
    cost_oecd: 20,
    poverty_change_household: 0.17,
    poverty_change_basic: 0.13
  },
  {
    Country: 'Cook Islands',
    poverty_reduction_basic: -0.18,
    poverty_reduction_enhanced: -0.42,
    poverty_reduction_ap_basic: -0.2,
    poverty_reduction_ap_enhanced: -0.41,
    inequality_reduction: -0.12,
    coverage: 0.82,
    consumption: 0.17,
    pmt_child: 0.34,
    pmt_disability: 0.48,
    pmt_old: 0.41,
    cost: 0.05,
    coverage_child: 0.42,
    coverage_disability: 0.18,
    coverage_old: 0.3,
    inequality_reduction_2: -0.29,
    inequality_reduction_ap: -0.1731728257,
    poverty_rate_no: 14.5,
    poverty_rate_basic: 5.36,
    poverty_rate_enhanced: 3.63,
    poverty_rate_ipl: 'USD 3.2',
    pmt_child_included: 0.64,
    pmt_child_excluded: 0.36,
    pmt_disability_included: 0.489,
    pmt_disability_excluded: 0.511,
    pmt_old_included: 0.7,
    pmt_old_excluded: 0.3,
    cost_child: 1,
    cost_disability: 0.3,
    cost_old: 2,
    cost_combined: 3,
    cost_ap: 4,
    cost_global: 12.9,
    cost_oecd: 20,
    poverty_change_household: 0.17,
    poverty_change_basic: 0.29
  },
  {
    Country: 'Georgia',
    poverty_reduction_basic: -0.1,
    poverty_reduction_enhanced: -0.3,
    poverty_reduction_ap_basic: -0.2,
    poverty_reduction_ap_enhanced: -0.41,
    inequality_reduction: -0.19,
    coverage: 0.95,
    consumption: 0.18,
    pmt_child: 0.56,
    pmt_disability: 0.48,
    pmt_old: 0.34,
    cost: 0.01,
    coverage_child: 0.46,
    coverage_disability: 0.07,
    coverage_old: 0.49,
    inequality_reduction_2: -0.12,
    inequality_reduction_ap: -0.1731728257,
    poverty_rate_no: 29.9,
    poverty_rate_basic: 15.82,
    poverty_rate_enhanced: 11.69,
    poverty_rate_ipl: 'USD 3.2',
    pmt_child_included: 0.51,
    pmt_child_excluded: 0.49,
    pmt_disability_included: 0.61,
    pmt_disability_excluded: 0.39,
    pmt_old_included: 0.47,
    pmt_old_excluded: 0.53,
    cost_child: 2,
    cost_disability: 0.7,
    cost_old: 1,
    cost_combined: 4,
    cost_ap: 4,
    cost_global: 12.9,
    cost_oecd: 20,
    poverty_change_household: 0.11,
    poverty_change_basic: 0.15
  },
  {
    Country: 'India',
    poverty_reduction_basic: -0.11,
    poverty_reduction_enhanced: -0.31,
    poverty_reduction_ap_basic: -0.2,
    poverty_reduction_ap_enhanced: -0.41,
    inequality_reduction: -0.11,
    coverage: 0.82,
    consumption: 0.16,
    pmt_child: 0.31,
    pmt_disability: 0.52,
    pmt_old: 0.39,
    cost: 0.03,
    coverage_child: 0.41,
    coverage_disability: 0.19,
    coverage_old: 0.27,
    inequality_reduction_2: -0.23,
    inequality_reduction_ap: -0.1731728257,
    poverty_rate_no: 54.9,
    poverty_rate_basic: 43.79,
    poverty_rate_enhanced: 41.35,
    poverty_rate_ipl: 'USD 3.2',
    pmt_child_included: 0.57,
    pmt_child_excluded: 0.43,
    pmt_disability_included: 0.69,
    pmt_disability_excluded: 0.31,
    pmt_old_included: 0.59,
    pmt_old_excluded: 0.41,
    cost_child: 1,
    cost_disability: 0.5,
    cost_old: 1,
    cost_combined: 3,
    cost_ap: 4,
    cost_global: 12.9,
    cost_oecd: 20,
    poverty_change_household: 0.1,
    poverty_change_basic: 0.11
  },
  {
    Country: 'Indonesia',
    poverty_reduction_basic: -0.12,
    poverty_reduction_enhanced: -0.5,
    poverty_reduction_ap_basic: -0.2,
    poverty_reduction_ap_enhanced: -0.41,
    inequality_reduction: -0.25,
    coverage: 0.87,
    consumption: 0.2,
    pmt_child: 0.51,
    pmt_disability: 0.32,
    pmt_old: 0.48,
    cost: 0.05,
    coverage_child: 0.52,
    coverage_disability: 0.06,
    coverage_old: 0.53,
    inequality_reduction_2: -0.14,
    inequality_reduction_ap: -0.1731728257,
    poverty_rate_no: 25.26,
    poverty_rate_basic: 12.47,
    poverty_rate_enhanced: 11.68,
    poverty_rate_ipl: 'USD 3.2',
    pmt_child_included: 0.69,
    pmt_child_excluded: 0.31,
    pmt_disability_included: 0.4,
    pmt_disability_excluded: 0.6,
    pmt_old_included: 0.5,
    pmt_old_excluded: 0.5,
    cost_child: 3,
    cost_disability: 1,
    cost_old: 2,
    cost_combined: 6,
    cost_ap: 4,
    cost_global: 12.9,
    cost_oecd: 20,
    poverty_change_household: 0.18,
    poverty_change_basic: 0.13
  },
  {
    Country: 'Kiribati',
    poverty_reduction_basic: -0.21,
    poverty_reduction_enhanced: -0.4,
    poverty_reduction_ap_basic: -0.2,
    poverty_reduction_ap_enhanced: -0.41,
    inequality_reduction: -0.16,
    coverage: 0.82,
    consumption: 0.17,
    pmt_child: 0.48,
    pmt_disability: 0.35,
    pmt_old: 0.33,
    cost: 0.01,
    coverage_child: 0.65,
    coverage_disability: 0.09,
    coverage_old: 0.21,
    inequality_reduction_2: -0.1,
    inequality_reduction_ap: -0.1731728257,
    poverty_rate_no: 14.57,
    poverty_rate_basic: 11.53,
    poverty_rate_enhanced: 11.02,
    poverty_rate_ipl: 'USD 3.2',
    pmt_child_included: 0.69,
    pmt_child_excluded: 0.31,
    pmt_disability_included: 0.5,
    pmt_disability_excluded: 0.5,
    pmt_old_included: 0.64,
    pmt_old_excluded: 0.36,
    cost_child: 2,
    cost_disability: 0.2,
    cost_old: 2,
    cost_combined: 4,
    cost_ap: 4,
    cost_global: 12.9,
    cost_oecd: 20,
    poverty_change_household: 0.14,
    poverty_change_basic: 0.28
  },
  {
    Country: 'Kyrgyzstan',
    poverty_reduction_basic: -0.21,
    poverty_reduction_enhanced: -0.46,
    poverty_reduction_ap_basic: -0.2,
    poverty_reduction_ap_enhanced: -0.41,
    inequality_reduction: -0.2,
    coverage: 0.8,
    consumption: 0.14,
    pmt_child: 0.56,
    pmt_disability: 0.47,
    pmt_old: 0.56,
    cost: 0.04,
    coverage_child: 0.45,
    coverage_disability: 0.17,
    coverage_old: 0.41,
    inequality_reduction_2: -0.1,
    inequality_reduction_ap: -0.1731728257,
    poverty_rate_no: 8.27,
    poverty_rate_basic: 4.79,
    poverty_rate_enhanced: 4.36,
    poverty_rate_ipl: 'USD 3.2',
    pmt_child_included: 0.49,
    pmt_child_excluded: 0.51,
    pmt_disability_included: 0.41,
    pmt_disability_excluded: 0.59,
    pmt_old_included: 0.67,
    pmt_old_excluded: 0.33,
    cost_child: 1,
    cost_disability: 0.15,
    cost_old: 1,
    cost_combined: 2,
    cost_ap: 4,
    cost_global: 12.9,
    cost_oecd: 20,
    poverty_change_household: 0.09,
    poverty_change_basic: 0.19
  },
  {
    Country: 'Maldives',
    poverty_reduction_basic: -0.15,
    poverty_reduction_enhanced: -0.43,
    poverty_reduction_ap_basic: -0.2,
    poverty_reduction_ap_enhanced: -0.41,
    inequality_reduction: -0.1,
    coverage: 0.79,
    consumption: 0.11,
    pmt_child: 0.35,
    pmt_disability: 0.52,
    pmt_old: 0.45,
    cost: 0.04,
    coverage_child: 0.44,
    coverage_disability: 0.14,
    coverage_old: 0.48,
    inequality_reduction_2: -0.27,
    inequality_reduction_ap: -0.1731728257,
    poverty_rate_no: 27.47,
    poverty_rate_basic: 24.13,
    poverty_rate_enhanced: 23.04,
    poverty_rate_ipl: 'USD 3.2',
    pmt_child_included: 0.66,
    pmt_child_excluded: 0.34,
    pmt_disability_included: 0.44,
    pmt_disability_excluded: 0.56,
    pmt_old_included: 0.41,
    pmt_old_excluded: 0.59,
    cost_child: 1,
    cost_disability: 0.3,
    cost_old: 1,
    cost_combined: 2,
    cost_ap: 4,
    cost_global: 12.9,
    cost_oecd: 20,
    poverty_change_household: 0.13,
    poverty_change_basic: 0.12
  },
  {
    Country: 'Mongolia',
    poverty_reduction_basic: -0.19,
    poverty_reduction_enhanced: -0.46,
    poverty_reduction_ap_basic: -0.2,
    poverty_reduction_ap_enhanced: -0.41,
    inequality_reduction: -0.17,
    coverage: 0.83,
    consumption: 0.15,
    pmt_child: 0.49,
    pmt_disability: 0.59,
    pmt_old: 0.41,
    cost: 0.06,
    coverage_child: 0.44,
    coverage_disability: 0.2,
    coverage_old: 0.25,
    inequality_reduction_2: -0.11,
    inequality_reduction_ap: -0.1731728257,
    poverty_rate_no: 7.9,
    poverty_rate_basic: 2.74,
    poverty_rate_enhanced: 2.57,
    poverty_rate_ipl: 'USD 3.2',
    pmt_child_included: 0.52,
    pmt_child_excluded: 0.48,
    pmt_disability_included: 0.45,
    pmt_disability_excluded: 0.55,
    pmt_old_included: 0.63,
    pmt_old_excluded: 0.37,
    cost_child: 2,
    cost_disability: 0.4,
    cost_old: 1,
    cost_combined: 3,
    cost_ap: 4,
    cost_global: 12.9,
    cost_oecd: 20,
    poverty_change_household: 0.11,
    poverty_change_basic: 0.27
  },
  {
    Country: 'Nepal',
    poverty_reduction_basic: -0.26,
    poverty_reduction_enhanced: -0.44,
    poverty_reduction_ap_basic: -0.2,
    poverty_reduction_ap_enhanced: -0.41,
    inequality_reduction: -0.25,
    coverage: 0.9,
    consumption: 0.11,
    pmt_child: 0.55,
    pmt_disability: 0.42,
    pmt_old: 0.44,
    cost: 0.06,
    coverage_child: 0.53,
    coverage_disability: 0.14,
    coverage_old: 0.21,
    inequality_reduction_2: -0.15,
    inequality_reduction_ap: -0.1731728257,
    poverty_rate_no: 26.28,
    poverty_rate_basic: 20.02,
    poverty_rate_enhanced: 19.1,
    poverty_rate_ipl: 'USD 1.9',
    pmt_child_included: 0.49,
    pmt_child_excluded: 0.51,
    pmt_disability_included: 0.66,
    pmt_disability_excluded: 0.34,
    pmt_old_included: 0.59,
    pmt_old_excluded: 0.41,
    cost_child: 2,
    cost_disability: 0.2,
    cost_old: 1,
    cost_combined: 3,
    cost_ap: 4,
    cost_global: 12.9,
    cost_oecd: 20,
    poverty_change_household: 0.14,
    poverty_change_basic: 0.17
  },
  {
    Country: 'Pakistan',
    poverty_reduction_basic: -0.28,
    poverty_reduction_enhanced: -0.37,
    poverty_reduction_ap_basic: -0.2,
    poverty_reduction_ap_enhanced: -0.41,
    inequality_reduction: -0.17,
    coverage: 0.79,
    consumption: 0.17,
    pmt_child: 0.51,
    pmt_disability: 0.38,
    pmt_old: 0.54,
    cost: 0.02,
    coverage_child: 0.66,
    coverage_disability: 0.19,
    coverage_old: 0.58,
    inequality_reduction_2: -0.14,
    inequality_reduction_ap: -0.1731728257,
    poverty_rate_no: 34.1,
    poverty_rate_basic: 25.62,
    poverty_rate_enhanced: 24.63,
    poverty_rate_ipl: 'USD 1.9',
    pmt_child_included: 0.64,
    pmt_child_excluded: 0.36,
    pmt_disability_included: 0.45,
    pmt_disability_excluded: 0.55,
    pmt_old_included: 0.41,
    pmt_old_excluded: 0.59,
    cost_child: 2.3,
    cost_disability: 1,
    cost_old: 2,
    cost_combined: 5,
    cost_ap: 4,
    cost_global: 12.9,
    cost_oecd: 20,
    poverty_change_household: 0.08,
    poverty_change_basic: 0.11
  },
  {
    Country: 'Philippines',
    poverty_reduction_basic: -0.14,
    poverty_reduction_enhanced: -0.34,
    poverty_reduction_ap_basic: -0.2,
    poverty_reduction_ap_enhanced: -0.41,
    inequality_reduction: -0.28,
    coverage: 0.89,
    consumption: 0.15,
    pmt_child: 0.57,
    pmt_disability: 0.34,
    pmt_old: 0.55,
    cost: 0.05,
    coverage_child: 0.68,
    coverage_disability: 0.08,
    coverage_old: 0.31,
    inequality_reduction_2: -0.23,
    inequality_reduction_ap: -0.1731728257,
    poverty_rate_no: 41.59,
    poverty_rate_basic: 31.64,
    poverty_rate_enhanced: 30.3,
    poverty_rate_ipl: 'USD 1.9',
    pmt_child_included: 0.45,
    pmt_child_excluded: 0.55,
    pmt_disability_included: 0.65,
    pmt_disability_excluded: 0.35,
    pmt_old_included: 0.45,
    pmt_old_excluded: 0.55,
    cost_child: 1,
    cost_disability: 0.5,
    cost_old: 1,
    cost_combined: 3,
    cost_ap: 4,
    cost_global: 12.9,
    cost_oecd: 20,
    poverty_change_household: 0.09,
    poverty_change_basic: 0.13
  },
  {
    Country: 'Sri Lanka',
    poverty_reduction_basic: -0.12,
    poverty_reduction_enhanced: -0.44,
    poverty_reduction_ap_basic: -0.2,
    poverty_reduction_ap_enhanced: -0.41,
    inequality_reduction: -0.11,
    coverage: 0.96,
    consumption: 0.18,
    pmt_child: 0.3,
    pmt_disability: 0.4,
    pmt_old: 0.47,
    cost: 0.01,
    coverage_child: 0.63,
    coverage_disability: 0.1,
    coverage_old: 0.23,
    inequality_reduction_2: -0.24,
    inequality_reduction_ap: -0.1731728257,
    poverty_rate_no: 10.36,
    poverty_rate_basic: 2.99,
    poverty_rate_enhanced: 2.84,
    poverty_rate_ipl: 'USD 1.9',
    pmt_child_included: 0.52,
    pmt_child_excluded: 0.48,
    pmt_disability_included: 0.62,
    pmt_disability_excluded: 0.38,
    pmt_old_included: 0.59,
    pmt_old_excluded: 0.41,
    cost_child: 1,
    cost_disability: 1,
    cost_old: 2,
    cost_combined: 4,
    cost_ap: 4,
    cost_global: 12.9,
    cost_oecd: 20,
    poverty_change_household: 0.12,
    poverty_change_basic: 0.29
  },
  {
    Country: 'Thailand',
    poverty_reduction_basic: -0.21,
    poverty_reduction_enhanced: -0.35,
    poverty_reduction_ap_basic: -0.2,
    poverty_reduction_ap_enhanced: -0.41,
    inequality_reduction: -0.19,
    coverage: 0.96,
    consumption: 0.07,
    pmt_child: 0.5,
    pmt_disability: 0.47,
    pmt_old: 0.47,
    cost: 0.01,
    coverage_child: 0.46,
    coverage_disability: 0.09,
    coverage_old: 0.44,
    inequality_reduction_2: -0.12,
    inequality_reduction_ap: -0.1731728257,
    poverty_rate_no: 8.16,
    poverty_rate_basic: 1.78,
    poverty_rate_enhanced: 1.62,
    poverty_rate_ipl: 'USD 1.9',
    pmt_child_included: 0.65,
    pmt_child_excluded: 0.35,
    pmt_disability_included: 0.54,
    pmt_disability_excluded: 0.46,
    pmt_old_included: 0.55,
    pmt_old_excluded: 0.45,
    cost_child: 3.2,
    cost_disability: 0.3,
    cost_old: 2,
    cost_combined: 5,
    cost_ap: 4,
    cost_global: 12.9,
    cost_oecd: 20,
    poverty_change_household: 0.2,
    poverty_change_basic: 0.12
  },
  {
    Country: 'Türkiye',
    poverty_reduction_basic: -0.22,
    poverty_reduction_enhanced: -0.37,
    poverty_reduction_ap_basic: -0.2,
    poverty_reduction_ap_enhanced: -0.41,
    inequality_reduction: -0.27,
    coverage: 0.89,
    consumption: 0.05,
    pmt_child: 0.34,
    pmt_disability: 0.35,
    pmt_old: 0.37,
    cost: 0.01,
    coverage_child: 0.7,
    coverage_disability: 0.16,
    coverage_old: 0.49,
    inequality_reduction_2: -0.22,
    inequality_reduction_ap: -0.1731728257,
    poverty_rate_no: 10.45,
    poverty_rate_basic: 4.18,
    poverty_rate_enhanced: 3.98,
    poverty_rate_ipl: 'USD 1.9',
    pmt_child_included: 0.57,
    pmt_child_excluded: 0.43,
    pmt_disability_included: 0.66,
    pmt_disability_excluded: 0.34,
    pmt_old_included: 0.62,
    pmt_old_excluded: 0.38,
    cost_child: 1,
    cost_disability: 0.3,
    cost_old: 2,
    cost_combined: 3,
    cost_ap: 4,
    cost_global: 12.9,
    cost_oecd: 20,
    poverty_change_household: 0.1,
    poverty_change_basic: 0.24
  },
  {
    Country: 'Viet Nam',
    poverty_reduction_basic: -0.14,
    poverty_reduction_enhanced: -0.46,
    poverty_reduction_ap_basic: -0.2,
    poverty_reduction_ap_enhanced: -0.41,
    inequality_reduction: -0.11,
    coverage: 0.92,
    consumption: 0.17,
    pmt_child: 0.3,
    pmt_disability: 0.55,
    pmt_old: 0.35,
    cost: 0.03,
    coverage_child: 0.54,
    coverage_disability: 0.11,
    coverage_old: 0.49,
    inequality_reduction_2: -0.16,
    inequality_reduction_ap: -0.1731728257,
    poverty_rate_no: 8.39,
    poverty_rate_basic: 4.92,
    poverty_rate_enhanced: 4.6,
    poverty_rate_ipl: 'USD 1.9',
    pmt_child_included: 0.49,
    pmt_child_excluded: 0.51,
    pmt_disability_included: 0.7,
    pmt_disability_excluded: 0.3,
    pmt_old_included: 0.68,
    pmt_old_excluded: 0.32,
    cost_child: 2,
    cost_disability: 0.1,
    cost_old: 1,
    cost_combined: 3,
    cost_ap: 4,
    cost_global: 12.9,
    cost_oecd: 20,
    poverty_change_household: 0.14,
    poverty_change_basic: 0.28
  },
  {
    Country: 'AP Average',
    poverty_reduction_basic: -0.18,
    poverty_reduction_enhanced: -0.41,
    poverty_reduction_ap_basic: '',
    poverty_reduction_ap_enhanced: '',
    inequality_reduction: -0.17,
    coverage: 0.86,
    consumption: 0.14,
    pmt_child: 0.44,
    pmt_disability: 0.45,
    pmt_old: 0.42,
    cost: 0.03,
    coverage_child: 0.55,
    coverage_disability: 0.12,
    coverage_old: 0.41,
    inequality_reduction_2: '',
    inequality_reduction_ap: '',
    poverty_rate_no: '',
    poverty_rate_basic: '',
    poverty_rate_enhanced: '',
    poverty_rate_ipl: '',
    pmt_child_included: 0.566,
    pmt_child_excluded: 0.43,
    pmt_disability_included: 0.55,
    pmt_disability_excluded: 0.45,
    pmt_old_included: 0.55,
    pmt_old_excluded: 0.45,
    cost_child: '',
    cost_disability: '',
    cost_old: '',
    cost_combined: '',
    cost_ap: '',
    cost_global: '',
    cost_oecd: '',
    poverty_change_household: '',
    poverty_change_basic: ''
  },
  {
    Country: 'Min',
    poverty_reduction_basic: 10,
    poverty_reduction_enhanced: 30,
    poverty_reduction_ap_basic: '',
    poverty_reduction_ap_enhanced: '',
    inequality_reduction: 0,
    coverage: 75,
    consumption: 5,
    pmt_child: 30,
    pmt_disability: 30,
    pmt_old: 30,
    cost: 1,
    coverage_child: 40,
    coverage_disability: 5,
    coverage_old: 20,
    inequality_reduction_2: '',
    inequality_reduction_ap: '',
    poverty_rate_no: '',
    poverty_rate_basic: '',
    poverty_rate_enhanced: '',
    poverty_rate_ipl: '',
    pmt_child_included: '',
    pmt_child_excluded: '',
    pmt_disability_included: '',
    pmt_disability_excluded: '',
    pmt_old_included: '',
    pmt_old_excluded: '',
    cost_child: 1,
    cost_disability: 0,
    cost_old: 1,
    cost_combined: '',
    cost_ap: '',
    cost_global: '',
    cost_oecd: '',
    poverty_change_household: '',
    poverty_change_basic: ''
  },
  {
    Country: 'Max',
    poverty_reduction_basic: 29,
    poverty_reduction_enhanced: 50,
    poverty_reduction_ap_basic: '',
    poverty_reduction_ap_enhanced: '',
    inequality_reduction: 20,
    coverage: 96,
    consumption: 20,
    pmt_child: 60,
    pmt_disability: 60,
    pmt_old: 60,
    cost: 6,
    coverage_child: 70,
    coverage_disability: 20,
    coverage_old: 60,
    inequality_reduction_2: '',
    inequality_reduction_ap: '',
    poverty_rate_no: '',
    poverty_rate_basic: '',
    poverty_rate_enhanced: '',
    poverty_rate_ipl: '',
    pmt_child_included: '',
    pmt_child_excluded: '',
    pmt_disability_included: '',
    pmt_disability_excluded: '',
    pmt_old_included: '',
    pmt_old_excluded: '',
    cost_child: 3,
    cost_disability: 1,
    cost_old: 2,
    cost_combined: '',
    cost_ap: '',
    cost_global: '',
    cost_oecd: '',
    poverty_change_household: '',
    poverty_change_basic: ''
  }
];
